const SUCCESS_SUFFIX = '_SUCCESS';
const FAILURE_SUFFIX = '_FAIL';
const CLEAR_PREFIX = 'CLEAR_';

export const GET_ROOT_SITE = 'GET_ROOT_SITE';
export const GET_SITE = 'GET_SITE';
export const SIGN_UP_NEWSLETTER = 'SIGN_UP_NEWSLETTER';
export const GET_CONTENTS = 'GET_CONTENTS';
export const SIGN_IN = 'SIGN_IN';
export const SIGN_UP = 'SIGN_UP';
export const GET_EXPERT_PROFILE = 'GET_EXPERT_PROFILE';
export const CURRENT_USER = 'CURRENT_USER';
export const SIGN_OUT = 'SIGN_OUT';
export const REDIRECT_TO = 'REDIRECT_TO';
export const GET_SCHEDULING_DATA = 'GET_SCHEDULING_DATA';
export const USER_SPECIFIC_SITE = 'USER_SPECIFIC_SITE';
export const GET_ACCOUNT_SETTINGS = 'GET_ACCOUNT_SETTINGS';
export const UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE';
export const CREATE_USER_PICTURE = 'CREATE_USER_PICTURE';
export const UPDATE_USER_PICTURE = 'UPDATE_USER_PICTURE';
export const DELETE_USER_PICTURE = 'DELETE_USER_PICTURE';
export const UPDATE_USER_PREFERENCES = 'UPDATE_USER_PREFERENCES';
export const CREATE_PAYMENT_METHOD = 'CREATE_PAYMENT_METHOD';
export const UPDATE_PAYMENT_METHOD = 'UPDATE_PAYMENT_METHOD';
export const UPDATE_USER_TERMS_SETTING = 'UPDATE_USER_TERMS_SETTING';
export const GET_EXPERT_SETTINGS = 'GET_EXPERT_SETTINGS';
export const UPDATE_EXPERT_DETAILS = 'UPDATE_EXPERT_DETAILS';
export const UPDATE_VACATION_MODE = 'UPDATE_VACATION_MODE';
export const GET_EXPERT_GLOBAL_SETTINGS = 'GET_EXPERT_GLOBAL_SETTINGS';
export const UPDATE_EXPERT_AVAILABILITY = 'UPDATE_EXPERT_AVAILABILITY';
export const CREATE_TIME_SLOT = 'CREATE_TIME_SLOT';
export const REMOVE_TIME_SLOT = 'REMOVE_TIME_SLOT';
export const UPDATE_CALENDAR_CONFIGURATIONS = 'UPDATE_CALENDAR_CONFIGURATIONS';
export const DELETE_CALENDAR_ACCOUNT = 'DELETE_CALENDAR_ACCOUNT';
export const UPDATE_GIFT_CARD_SETTING = 'UPDATE_GIFT_CARD_SETTING';
export const CREATE_SESSION = 'CREATE_SESSION';
export const UPDATE_SESSION = 'UPDATE_SESSION';
export const DELETE_SESSION = 'DELETE_SESSION';
export const UPDATE_SESSION_SETTINGS = 'UPDATE_SESSION_SETTINGS';
export const CREATE_SESSION_PACK = 'CREATE_SESSION_PACK';
export const UPDATE_SESSION_PACK = 'UPDATE_SESSION_PACK';
export const DELETE_SESSION_PACK = 'DELETE_SESSION_PACK';
export const UPDATE_PAYOUT_METHOD = 'UPDATE_PAYOUT_METHOD';
export const EXPERT_SIGN_UP = 'EXPERT_SIGN_UP';
export const CONFIRM_USER = 'CONFIRM_USER';
export const USER_RESET_PASSWORD = 'USER_RESET_PASSWORD';
export const USER_JOIN_AS_MEMBER = 'USER_JOIN_AS_MEMBER';
export const USER_JOIN_AS_EXPERT = 'USER_JOIN_AS_EXPERT';
export const DISCONNECT_ZOOM_ACCOUNT = 'DISCONNECT_ZOOM_ACCOUNT';
export const UPDATE_ZOOM_CONFIGURATIONS = 'UPDATE_ZOOM_CONFIGURATIONS';
export const ENABLE_ZOOM_CO_HOST = 'ENABLE_ZOOM_CO_HOST';
export const GET_EXPERT_SESSIONS_SETTING = 'GET_EXPERT_SESSIONS_SETTING';
export const GET_EXPERT_PACKAGES = 'GET_EXPERT_PACKAGES';
export const UPDATE_CURRENCY_LIMITATIONS = 'UPDATE_CURRENCY_LIMITATIONS';
export const GET_EXPERT_VOLUNTEERINGS = 'GET_EXPERT_VOLUNTEERINGS';
export const UPDATE_EXPERT_VOLUNTEERING = 'UPDATE_EXPERT_VOLUNTEERING';
export const PAUSE_EXPERT_VOLUNTEERING = 'PAUSE_EXPERT_VOLUNTEERING';
export const RESUME_EXPERT_VOLUNTEERING = 'RESUME_EXPERT_VOLUNTEERING';
export const ARCHIVE_EXPERT_VOLUNTEERING = 'ARCHIVE_EXPERT_VOLUNTEERING';
export const CREATE_EXPERT_VOLUNTEERING = 'CREATE_EXPERT_VOLUNTEERING';
export const SIGN_IN_WITH_TOKEN = 'SIGN_IN_WITH_TOKEN';
export const PREVENT_DETECTING_AUTHENTICATED_USER = 'PREVENT_DETECTING_AUTHENTICATED_USER';
export const SHOW_CONFIRM_NAVIGATION_MODAL = 'SHOW_CONFIRM_NAVIGATION_MODAL';
export const CLEAR_SUBMITED_SIGNED_IN_SIGNAL = 'CLEAR_SUBMITED_SIGNED_IN_SIGNAL';
export const SUBMIT_ONBOARDING = 'SUBMIT_ONBOARDING';
export const VISIT_ONBOARDING_STEP = 'VISIT_ONBOARDING_STEP';
export const GET_SITE_VISIBLE_KEYWORDS = 'GET_SITE_VISIBLE_KEYWORDS';
export const COMPLETE_REGISTRATION = 'COMPLETE_REGISTRATION';
export const UPDATE_EXPERT_VISIBILITY = 'UPDATE_EXPERT_VISIBILITY';
export const ADD_LOADING_API = 'ADD_LOADING_API';
export const CLEAR_LOADED_API = 'CLEAR_LOADED_API';
export const GET_IN_PERSON_MEETING_LOCATIONS = 'GET_IN_PERSON_MEETING_LOCATIONS';
export const UPDATE_IN_PERSON_MEETING_LOCATIONS = 'UPDATE_IN_PERSON_MEETING_LOCATIONS';
export const GET_IN_PERSON_MEETING_LOCATIONS_FOR_SCHEDULING = 'GET_IN_PERSON_MEETING_LOCATIONS_FOR_SCHEDULING';
export const CREATE_GIFT_CARD_APPEARANCE = 'CREATE_GIFT_CARD_APPEARANCE';
export const UPDATE_GIFT_CARD_APPEARANCE = 'UPDATE_GIFT_CARD_APPEARANCE';
export const DELETE_GIFT_CARD_APPEARANCE = 'DELETE_GIFT_CARD_APPEARANCE';
export const GET_EXPERT_VISIBILE_SESSIONS = 'GET_EXPERT_VISIBILE_SESSIONS';
export const GET_EXPERT_VISIBILE_PACKAGES = 'GET_EXPERT_VISIBILE_PACKAGES';
export const OBSERVE_DETECTING_AUTHENTICATED_USER = 'OBSERVE_DETECTING_AUTHENTICATED_USER';
export const CLEAR_AUTH_TOKEN = 'CLEAR_AUTH_TOKEN';
export const SET_MFA_CHALLENGE = 'SET_MFA_CHALLENGE';
export const CLEAR_MFA_CHALLENGE = 'CLEAR_MFA_CHALLENGE';
export const GET_DOWNLOAD_APP_MESSAGES = 'GET_DOWNLOAD_APP_MESSAGES';
export const GET_EXPERT_AVAILABLE_STRIPE_ACCOUNTS = 'GET_EXPERT_AVAILABLE_STRIPE_ACCOUNTS';
export const GET_AVAILABLE_CHARITIES_FOR_RECOMMENDATION = 'GET_AVAILABLE_CHARITIES_FOR_RECOMMENDATION';
export const GET_EXPERT_BADGES = 'GET_EXPERT_BADGES';
export const UPDATE_LANGUAGE = 'UPDATE_LANGUAGE';
export const INIT_CUSTOM_PAGE_CONTENTS = 'INIT_CUSTOM_PAGE_CONTENTS';
export const GET_SITE_CUSTOM_PAGES = 'GET_SITE_CUSTOM_PAGES';
export const INITIALIZE_CUSTOM_PAGE_DATA = 'INITIALIZE_CUSTOM_PAGE_DATA';
export const GET_SESSIONS_CONTENTS = 'GET_SESSIONS_CONTENTS';
export const GET_USER_PHONES_FOR_SITE = 'GET_USER_PHONES_FOR_SITE';
export const CREATE_PHONE_VERIFICATION = 'CREATE_PHONE_VERIFICATION';
export const VERIFY_USER_PHONE = 'VERIFY_USER_PHONE';
export const SET_DEFAULT_PHONE_FOR_SITE = 'SET_DEFAULT_PHONE_FOR_SITE';
export const SHOW_UNREAD_NOTIFICATION_COUNT = 'SHOW_UNREAD_NOTIFICATION_COUNT';
export const UPDATE_UNREAD_NOTIFICATION_COUNT = 'UPDATE_UNREAD_NOTIFICATION_COUNT';
export const GET_UNREAD_NOTIFICATION_COUNT = 'GET_UNREAD_NOTIFICATION_COUNT';
export const FETCH_NEW_NOTIFICATION = 'FETCH_NEW_NOTIFICATION';
export const TOGGLE_SIDEBAR_MENU = 'TOGGLE_SIDEBAR_MENU';
export const SET_SIDEBAR_MENU = 'SET_SIDEBAR_MENU';
export const SIGN_IN_WITH_AUTH0_USER = 'SIGN_IN_WITH_AUTH0_USER';
export const GET_SITE_ASSOCIATIONS = 'GET_SITE_ASSOCIATIONS';
export const INITIALIZE_USER_TOKEN = 'INITIALIZE_USER_TOKEN';
export const REFRESH_AUTH_TOKEN = 'REFRESH_AUTH_TOKEN';
export const INITIALIZE_ADMIN_TOKEN = 'INITIALIZE_ADMIN_TOKEN';
export const GET_DESIGN_PATHS = 'GET_DESIGN_PATHS';
export const UPDATE_CURRENT_USER_AVATAR = 'UPDATE_CURRENT_USER_AVATAR';
export const HIDE_DESIGNS_OVERLAY = 'HIDE_DESIGNS_OVERLAY';

export const ADMIN_GET_SIDEBAR_MENU = 'ADMIN_GET_SIDEBAR_MENU';
export const ADMIN_GET_DESIGN_ITEMS = 'ADMIN_GET_DESIGN_ITEMS';
export const ADMIN_SIGN_IN_WITH_TOKEN = 'ADMIN_SIGN_IN_WITH_TOKEN';
export const ADMIN_GET_TEMPLATE_BLOCKS = 'ADMIN_GET_TEMPLATE_BLOCKS';
export const ADMIN_REFRESH_TOKEN = 'ADMIN_REFRESH_TOKEN';
export const ADMIN_GET_DEFAULT_BLOCK_CONTENTS = 'ADMIN_GET_DEFAULT_BLOCK_CONTENTS';
export const ADMIN_OBSERVE_DEFAULT_BLOCK_CONTENTS = 'ADMIN_OBSERVE_DEFAULT_BLOCK_CONTENTS';
export const ADMIN_UPDATE_PAGE_TITLE = 'ADMIN_UPDATE_PAGE_TITLE';
export const ADMIN_CLEAR_TOKEN = 'ADMIN_CLEAR_TOKEN';
export const UPDATE_SITE_THEME = 'UPDATE_SITE_THEME';

export const ActionSuccessType = (action) => action.concat(SUCCESS_SUFFIX);

export const ActionFailureType = (action) => action.concat(FAILURE_SUFFIX);

export const ActionClearType = (action) => CLEAR_PREFIX.concat(action);
